export const sexs = [
    {
        key: 1,
        value: '男'
    }, {
        key: 2,
        value: '女'
    }
]
export const yn = [
    {
        key: -1,
        value: '无'
    }, {
        key: 1,
        value: '有'
    }
]
// 大队辅导员
export const starts = [
    {
        key: 1,
        value: '有'
    }, {
        key: 2,
        value: '否'
    }, {
        key: -1,
        value: '未开展'
    }
]

// 大队辅导员
export const sgwlist = [
    {
        key: 1,
        value: '有'
    }, {
        key: 2,
        value: '无'
    }, {
        key: -1,
        value: '没有成立'
    }
]


export const yORn = [
    {
        key: 1,
        value: '是'
    }, {
        key: 2,
        value: '否'
    }
]
export const buildingTeamList = [
    {
        key: 1,
        value: '是'
    }, {
        key: 2,
        value: '否'
    }, {
        key: 3,
        value: '不符合建队条件'
    }
]
export const schoolTypes = [{
    key: 1,
    value: '公立小学'
}, {
    key: 2,
    value: '私立小学'
}, {
    key: 3,
    value: '公立初中'
}, {
    key: 4,
    value: '私立初中'
}, {
    key: 5,
    value: '公立 9 年一贯制'
}, {
    key: 6,
    value: '私立 9 年一贯制'
}, {
    key: 7,
    value: '公立12年一贯制学校'
}, {
    key: 8,
    value: '私立12年一贯制学校'
}, {
    key: 9,
    value: '公立完全中学'
}, {
    key: 10,
    value: '私立完全中学'
}]
export const eduList = [{
    key: 1,
    value: '全日制研究生'
}, {
    key: 2,
    value: '在职研究生'
}, {
    key: 3,
    value: '党校研究生'
}, {
    key: 4,
    value: '全日制本科'
},{
    key: 5,
    value: '非全日制本科'
}, {
    key: 6,
    value: '全日制大专'
}, {
    key: 7,
    value: '非全日制大专'
}, {
    key: 8,
    value: '其他'
}]

export const traineeTypeList = [{
    key: 1,
    value: '地方各级少工委负责人'
}, {
    key: 2,
    value: '各级少先队总辅导员'
}, {
    key: 3,
    value: '中小学校少先队辅导员'
}, {
    key: 4,
    value: '中小学校少工委主任'
}, {
    key: 5,
    value: '青少年宫负责人'
}, {
    key: 6,
    value: '少先队校外辅导员'
}, {
    key: 7,
    value: '团校和高校教研骨干'
}, {
    key: 8,
    value: '其他少先队工作者'
}]
export const zzmmList = [{
    key: 1,
    value: '中共党员'
}, {
    key: 2,
    value: '共青团员'
}, {
    key: 3,
    value: '群众'
}, {
    key: 4,
    value: '其他'
}]
export const titleList = [{
    key: 1,
    value: '三级及以下'
}, {
    key: 2,
    value: '二级'
}, {
    key: 3,
    value: '一级'
}, {
    key: 4,
    value: '高级'
}, {
    key: 5,
    value: '正高级'
}]

export const concurrentCoursesList = [{
    key: 1,
    value: '无'
}, {
    key: 2,
    value: '只兼语文/数学/外语等主课'
}, {
    key: 3,
    value: '只兼思政课'
}, {
    key: 4,
    value: '只兼其他课程'
}, {
    key: 5,
    value: '同时兼思政课和主课'
}, {
    key: 6,
    value: '同时兼思政课和其他课'
}, {
    key: 7,
    value: '同时兼主课和其他课'
}]

export const batchTeamList = [{
    key: 1,
    value: '未分批'
},{
    key: 2,
    value: '分两批'
},{
    key: 3,
    value: '分三批'
},{
    key: 4,
    value: '其他'
}]

export const sgwJobList = [{
    key: 1,
    value: '党员校长'
},{
    key: 2,
    value: '学校党组织书记'
},{
    key: 3,
    value: '非党员校长'
},{
    key: 4,
    value: '其他'
}]

export const jobList =  [{
    key: 1,
    value: '校长兼任'
},{
    key: 2,
    value: '副校长兼任'
},{
    key: 3,
    value: '兼任德育主任'
},{
    key: 4,
    value: '兼任德育副主任'
},{
    key: 5,
    value: '相当于德育主任职级'
},{
    key: 6,
    value: '相当于德育副主任职级'
},{
    key: 7,
    value: '无职级'
}]

export const levelJobList = [{
    key: 1,
    value: '团委主要负责同志'
},{
    key: 2,
    value: '团委负责同志'
},{
    key: 3,
    value: '团委其他同志'
},{
    key: 4,
    value: '教育部门负责同志'
},{
    key: 5,
    value: '教育部门其他同志'
}]

export const companyList =  [{
    key: 1,
    value: '同级团委'
}, {
    key: 2,
    value: '同级教育部门'
}, {
    key: 3,
    value: '青少年宫'
}, {
    key: 4,
    value: '其他团属事业单位'
}, {
    key: 5,
    value: '其他教育部门下属事业单位'
}, {
    key: 6,
    value: '中小学校'
}, {
    key: 7,
    value: '其他'
}]

export const administrationList = [{
    key: 1,
    value: '中层正职（含）以上'
}, {
    key: 2,
    value: '中层副职'
}, {
    key: 3,
    value: '中层副职以下'
}, {
    key: 4,
    value: '无'
}]
export const postTypeList =  [{
    key: 1,
    value: '专职'
}, {
    key: 2,
    value: '兼职'
}]

export const levelSGWDirectorList = [{
    key: 1,
    value: '1人'
}, {
    key: 2,
    value: '2人'
}]

export const trainLevelList = [
    {
        key: 1,
        value: '全国级'
    }, {
        key: 2,
        value: '省级'
    }, {
        key: 3,
        value: '市级'
    }, {
        key: 4,
        value: '县级'
    }
]

export const viceCounselorList = [
    {
        key: 1,
        value: '0-10'
    }, {
        key: 2,
        value: '10人以上'
    }
]

export const organizerList = [
    {
        key: 1,
        value: '团委或少工委'
    }, {
        key: 2,
        value: '教育部门'
    }, {
        key: 3,
        value: '团属事业单位'
    }, {
        key: 4,
        value: '教育部门下属事业单位'
    }, {
        key: 5,
        value: '其他机构'
    }
]

export const meetingList = [
    {
        key: 1,
        value: '时间范围内'
    }, {
        key: 0,
        value: '不在时间范围内'
    }, {
        key: -1,
        value: '未填写'
    }
]

export const sponsorTypes = schoolTypes.concat([
    {
        key: 11,
        value: '区县级团委、少工委及直属单位、合作机构'
    },
    {
        key: 12,
        value: '地市级团委、少工委及直属单位、合作机构'
    },
    {
        key: 13,
        value: '省级团委、少工委及直属单位、合作机构'
    },
    {
        key: 14,
        value: '社区（街道、乡镇、村）少先队组织'
    },
    {
        key: 15,
        value: '其他'
    }
])
export const activeThemes = [
    {
        key: 1,
        value: '红色教育'
    },
    {
        key: 2,
        value: '国防教育（少年军校）'
    },
    {
        key: 3,
        value: '法治教育'
    },
    {
        key: 4,
        value: '安全教育（少年警校）'
    },
    {
        key: 5,
        value: '民族团结'
    },
    {
        key: 6,
        value: '科技创新（少年科学院）'
    },
    {
        key: 7,
        value: '文化艺术'
    },
    {
        key: 8,
        value: '体育竞技'
    },
    {
        key: 9,
        value: '职业体验'
    },
    {
        key: 10,
        value: '其他'
    }
]
export const activeTypes = [
    {
        key: 1,
        value: '实践营'
    },
    {
        key: 2,
        value: '托管'
    },
    {
        key: 3,
        value: '培训'
    },
    {
        key: 4,
        value: '其他'
    },
]

// 所在学校的日常少先队活动时间如何安排？（单选）
export const eventScheduleList = [{
    key: 1,
    value: 'A每周至少1课时少先队活动，纳入课表'
}, {
    key: 2,
    value: 'B每周至少1课时班队（班团队）活动，纳入课表'
}, {
    key: 3,
    value: 'C每周至少1次少先队活动，纳入课后服务'
}, {
    key: 4,
    value: 'D每周至少1次，利用升旗仪式、大课间等时间'
}, {
    key: 5,
    value: 'E不定期安排'
}]

export const zzmmList01 = [{
    key: 1,
    value: '中共党员'
}, {
    key: 2,
    value: '预备党员'
},{
    key: 3,
    value: '共青团员'
}, {
    key: 4,
    value: '群众'
}, {
    key: 5,
    value: '其他'
}]
export const fdySXLevList = [{
    key: 1,
    value: '省（自治区、直辖市）'
},
//  {
//     key: 2,
//     value: '市（地、州、盟）'
// }, 
{
    key: 3,
    value: '县（市、区、旗）'
}
]
export const fdyLevList = [{
    key: 1,
    value: '省、自治区、直辖市'
}, {
    key: 2,
    value: '地、市、州、盟'
}, {
    key: 3,
    value: '县、市、区、旗'
}]

export const eduList01 = [{
    key: 1,
    value: '中专'
}, {
    key: 2,
    value: '大专'
}, {
    key: 3,
    value: '本科'
}, {
    key: 4,
    value: '硕士研究生'
},{
    key: 5,
    value: '博士研究生'
}]

export const majorList = [{
    key: 1,
    value: '哲学'
}, {
    key: 2,
    value: '经济学'
}, {
    key: 3,
    value: '法学'
}, {
    key: 4,
    value: '教育学'
},{
    key: 5,
    value: '文学'
},{
    key: 6,
    value: '历史学'
},{
    key: 7,
    value: '理学'
},{
    key: 8,
    value: '工学'
},{
    key: 9,
    value: '农学'
},{
    key: 10,
    value: '医学'
},{
    key: 11,
    value: '管理学'
},{
    key: 12,
    value: '军事学'
},{
    key: 13,
    value: '艺术学'
}]

export const highestEduList = [{
    key: 1,
    value: '与全日制教育学历一致'
}, {
    key: 2,
    value: '中专'
}, {
    key: 3,
    value: '大专'
}, {
    key: 4,
    value: '本科'
},{
    key: 5,
    value: '硕士研究生'
},{
    key: 6,
    value: '博士研究生'
}]

export const highestEduXZList = [
//     {
//     key: 1,
//     value: '普通全日制本科'
// },
 {
    key: 2,
    value: '非全日制本科'
}, 
// {
//     key: 3,
//     value: '普通全日制研究生'
// }, 
{
    key: 4,
    value: '非全日制研究生'
},{
    key: 5,
    value: '在职研究生'
},{
    key: 6,
    value: '其他'
}]

export const organizationList = [{
    key: 1,
    value: '团委机关'
}, {
    key: 2,
    value: '团属单位'
}, {
    key: 3,
    value: '教育局（委）机关'
}, {
    key: 4,
    value: '教育局（委）所属单位（非中小学）'
},{
    key: 5,
    value: '中小学校'
},{
    key: 6,
    value: '其他'
}]

export const tuanJobList = [{
    key: 1,
    value: '团（工）委书记'
}, {
    key: 2,
    value: '团（工）委副书记'
}, {
    key: 3,
    value: '团委委员'
}, {
    key: 4,
    value: '团（总）支部书记'
},{
    key: 5,
    value: '团（总）支部副书记'
},{
    key: 6,
    value: '团（总）支部委员'
},{
    key: 7,
    value: '无团内职务'
}]

export const jobTypeList = [{
    key: 1,
    value: '公务员（含参公）'
}, {
    key: 2,
    value: '事业编制'
}, {
    key: 3,
    value: '国有企业'
}, {
    key: 4,
    value: '无编制'
}]

export const jobLevList = [{
    key: 1,
    value: '正局级'
}, {
    key: 2,
    value: '副局级'
}, {
    key: 3,
    value: '正处级'
}, {
    key: 4,
    value: '副处级'
}, {
    key: 5,
    value: '正科级'
}, {
    key: 6,
    value: '副科级'
}, {
    key: 7,
    value: '其他'
}]

export const teachSubjectNumList = [{
    key: 1,
    value: '无教学任务'
}, {
    key: 2,
    value: '1 门'
}, {
    key: 3,
    value: '2 门'
}, {
    key: 4,
    value: '3 门'
}, {
    key: 5,
    value: '4 门'
}, {
    key: 6,
    value: '5 门及以上'
}]

export const teachSubjectsList = [{
    key: 1,
    value: '语文'
}, {
    key: 2,
    value: '数学'
}, {
    key: 3,
    value: '英语'
}, {
    key: 4,
    value: '体育'
}, {
    key: 5,
    value: '道德与法治'
}, {
    key: 6,
    value: '音乐'
}, {
    key: 7,
    value: '美术'
}, {
    key: 8,
    value: '科学'
}, {
    key: 9,
    value: '劳动教育'
}, {
    key: 10,
    value: '其他'
}]

export const schoolTypeList = [{
    key: 1,
    value: '小学'
}, {
    key: 2,
    value: '初中'
}, {
    key: 3,
    value: '九年一贯制'
}, {
    key: 4,
    value: '十二年一贯制'
}, {
    key: 5,
    value: '完全中学'
}]

export const schoolAreaList = [{
    key: 1,
    value: '城区'
}, {
    key: 2,
    value: '镇区'
}, {
    key: 3,
    value: '乡村'
}]

export const ruduiPiciList = [{
    key: 1,
    value: '同时同批入队'
}, {
    key: 2,
    value: '2批'
}, {
    key: 3,
    value: '3批'
}, {
    key: 4,
    value: '4批及以上'
}]

export const sxdClassMList = [{
    key: 1,
    value: '10㎡以下'
}, {
    key: 2,
    value: '10㎡（含）-30㎡'
}, {
    key: 3,
    value: '30㎡（含）-50㎡'
}, {
    key: 4,
    value: '50㎡（含）-100㎡'
}, {
    key: 5,
    value: '100㎡（含）以上'
}]

export const fDaDuifdyMList = [{
    key: 1,
    value: '1人'
}, {
    key: 2,
    value: '2人'
}, {
    key: 3,
    value: '3人'
}, {
    key: 4,
    value: '4人'
}, {
    key: 5,
    value: '5人'
}, {
    key: 6,
    value: '6人'
}, {
    key: 7,
    value: '7人'
}, {
    key: 8,
    value: '8人'
}, {
    key: 9,
    value: '9人'
}, {
    key: 10,
    value: '10人'
}]

export const sxdGhdPopList = [{
    key: 1,
    value: '大型'
}, {
    key: 2,
    value: '中型'
}, {
    key: 3,
    value: '小型'
}]

export const sxdHdkList = [{
    key: 1,
    value: '每周1课时'
}, {
    key: 2,
    value: '隔周1课时'
}, {
    key: 3,
    value: '每月1课时'
}, {
    key: 4,
    value: '未安排'
}]

export const sgwZhuRenList1 = [{
    key: 1,
    value: '党组织书记兼校长'
}, {
    key: 2,
    value: '党组织书记'
}, {
    key: 3,
    value: '校长'
}, {
    key: 4,
    value: '副校级领导'
}, {
    key: 5,
    value: '其他人员'
}, {
    key: 6,
    value: '全年未配备'
}]
export const sgwZhuRenList = [{
    key: 6,
    value: '未建立学校少工委'
},{
    key: 1,
    value: '党组织书记兼校长'
}, {
    key: 2,
    value: '党组织书记'
}, {
    key: 3,
    value: '校长'
}, {
    key: 4,
    value: '副校级领导'
}, {
    key: 5,
    value: '其他人员'
}]

export const zzmmList02 = [{
    key: 1,
    value: '中共党员'
}, {
    key: 2,
    value: '中共预备党员'
},{
    key: 3,
    value: '共青团员'
}, {
    key: 4,
    value: '群众'
}, {
    key: 5,
    value: '其他'
}]

export const daDuiFdyTpyeList = [{
    key: 1,
    value: '大队辅导员'
}, {
    key: 2,
    value: '副大队辅导员'
},{
    key: 3,
    value: '代履行大队辅导员职责的其他人员'
}]

export const haveTuanJobMajorList = [{
    key: 1,
    value: '团委书记'
}, {
    key: 2,
    value: '团委副书记'
},{
    key: 3,
    value: '团委委员'
},{
    key: 4,
    value: '团（总）支部书记'
},{
    key: 5,
    value: '团（总）支部副书记'
},{
    key: 6,
    value: '团（总）支部委员'
}]

export const schoolMajorList = [{
    key: 1,
    value: '党组织书记兼校长'
}, {
    key: 2,
    value: '党组织书记'
},{
    key: 3,
    value: '校长'
},{
    key: 4,
    value: '副校级领导'
},{
    key: 5,
    value: '德育主任'
},{
    key: 6,
    value: '其他人员'
}]

export const salaryList = [{
    key: 1,
    value: '中层副'
}, {
    key: 2,
    value: '中层正'
},{
    key: 3,
    value: '副校级领导'
},{
    key: 4,
    value: '无级别'
}]

export const jobTitleList = [{
    key: 1,
    value: '三级教师（员级）'
}, {
    key: 2,
    value: '二级教师（助理级）'
},{
    key: 3,
    value: '一级教师（中级）'
},{
    key: 4,
    value: '高级教师'
},{
    key: 5,
    value: '正高级教师'
},{
    key: 6,
    value: '未定级或无职称'
}]

export const schoolOutAreaList = [{
    key: 1,
    value: '省、自治区、直辖市'
}, {
    key: 2,
    value: '地、市、州、盟'
},{
    key: 3,
    value: '县、区、旗'
}]

export const organizationTypeList = [{
    key: 1,
    value: '街道少工委'
}, {
    key: 2,
    value: '乡镇少工委'
},{
    key: 3,
    value: '社区少工委'
},{
    key: 4,
    value: '村少工委'
}]

export const sgwZhuRenMajorList = [{
    key: 1,
    value: '乡镇（街道）党政正职'
}, {
    key: 2,
    value: '乡镇（街道）党政副职'
},{
    key: 3,
    value: '村（社区）两委正职'
},{
    key: 4,
    value: '村（社区）两委副职'
},{
    key: 5,
    value: '社区工作者'
},{
    key: 6,
    value: '社会组织社工'
},{
    key: 7,
    value: '志愿者'
},{
    key: 8,
    value: '其他'
}]
